import { MovementTypes } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { BarcodeReader, Field, Form } from '@skinsoft/ui';
import { Config } from 'final-form';
import { Component, Vue } from 'vue-property-decorator';

import { LocationSelector } from '@skinsoft/entity-ui';

export interface Values {
    location: string;
    permanentLocation: boolean;
}

@Component({
    components: {
        sBarcodeReader: BarcodeReader,
        sLocationSelector: LocationSelector
    },
    props: ['onSubmit', 'initialValues', 'movementType'],
    template: require('./close-form.html'),
})
export class CloseForm extends ReactiveVue {
    public onSubmit: Config['onSubmit'];
    public initialValues: Values;
    public movementType: MovementTypes;

    public MovementTypes = MovementTypes;

    public $refs: {
        barcodeReader: BarcodeReader;
        form: Form;
        location: Field;
    };

    private isLocationSelected = false;

    public validate(values): Promise<object> {
        return new Promise(resolve => {
            // need to be a promise to avoid conflict with $t mixin
            const errors = {} as any;

            if (this.movementType === MovementTypes.SIMPLE) {
                if (!values.location) {
                    errors.location = this.$t('entity.closeMovement.form.location.emptyError');
                }
            }

            resolve(errors);
        });
    }

    public onBarcodeReaderInput(location: Values['location']) {
        const form = this.$refs.form.form;

        form.batch(() => {
            form.change('location', location);
            form.mutators.setFieldTouched('location', true);
        });
    }

    public onLocationSelected(locationChangeEvent) {
        if (locationChangeEvent.location) {
            this.isLocationSelected = true;
            const form = this.$refs.form.form;

            form.batch(() => {
                form.change('location', locationChangeEvent.location);
                form.mutators.setFieldTouched('location', true);
            });
        } else {
            this.isLocationSelected = false;
        }
    }
}
